import Details from './ActionPlanDetails';
import List from './ActionPlans';
import CompanyView from './CompanyView/ActionPlansCompanyView';

export default {
  List,
  Details,
  CompanyView,
};
